import React from "react";
import "../css/Approach.css";
import poIcon from "../assets/images/Aifrica (6).png";
import poIconEn from "../assets/images/ApproachEnglais.jpeg";
import { useLanguage } from "../contexts/LanguageContext";


export default function Approach() {
  const { t, language } = useLanguage();
  
  // Utiliser l'image anglaise si la langue est 'en', sinon l'image française
  const approachImage = language === 'en' ? poIconEn : poIcon;
  
  return (
    <section id="approach" className="approach-new">
      <img src={approachImage} alt={t('navbar.approach', 'Approach')} className="approach-img" />
    </section>
  );
}
